import { ApplicationState } from "@idw-types/state";
import { TmxState } from "@idw-types/state/tmx-state";
import { createSelector } from "reselect";

export const getTmxState = (state: ApplicationState) => {
	return state.tmx;
};

export const getIsTmxProfilingCompleted = createSelector(getTmxState, (tmxState: TmxState) => {
    return tmxState.isTmxProfilingCompleted;
});

export const getTmxError = createSelector(getTmxState, (tmxState: TmxState) => {
    return tmxState.error;
});